import { render, staticRenderFns } from "./ClientBranchList.vue?vue&type=template&id=1bce19ce&lang=pug"
import script from "./ClientBranchList.vue?vue&type=script&lang=js"
export * from "./ClientBranchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports